import React, { useEffect, useRef, useState } from "react";
import { icons } from "../../assets/icons";
import { gsap } from "gsap";
import { isMovilResponsive } from "../../helpers/Constnats";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";

const namesCharactes = {
	"1": "Andatti",
	"2": "Chip OXXO",
	"3": "Spin Premia",
	"4": "Spinner",
}
export const DialogActivities = ({ dialog = "", percentage }) => {
	const [nameTitle, setNameTitle] = useState(namesCharactes[1])

	useEffect(() => {
		const selectCharacter = localStorage.getItem("character") ?? "1"
		setNameTitle(namesCharactes[selectCharacter])
	}, [])

	const containerInit = useRef(null);
	const containerGlobal = useRef(null);
	const containerInfo = useRef(null);
	const [animacionActiva, setAnimacionActiva] = useState(false);

	const tooggleAnimation = () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationInfo)
		const initContainer = containerInit.current;
		const container = containerGlobal.current;
		const info = containerInfo.current;

		if (!containerGlobal.current || !containerInfo.current) return;

		if (!animacionActiva) {
			gsap.to(initContainer, {
				width: isMovilResponsive ? "120px" : "216px",
				duration: 1,
			})
			gsap.to(container, { width: isMovilResponsive ? "40px" : "72px", borderRadius: "40px", duration: 0.5 });
			gsap.to(info, { opacity: 0, duration: 0.2 });
		} else {
			gsap.to(initContainer, {
				width: "80%",
				duration: 1,
			})
			gsap.to(container, {
				width: "100%",
				borderRadius: "24px",
				duration: 0.5,
				onComplete: () => {
					gsap.to(info, { opacity: 1, duration: 0.5 });
				},
			});
		}
		setAnimacionActiva(!animacionActiva);
	};

	return (
		<div ref={containerInit} className={`fixed z-40 bottom-0 h-[120px] md:h-[200px] w-[80%]`}>
			<div className="flex px-10 py-3 md:py-7 overflow-hidden h-full">
				{/* datos w-[40px] md:w-[72px] rounded-[40px] y cuado cree rounded-[24px]*/}
				<div ref={containerGlobal} className="w-full rounded-[24px] h-full bg-[#292929c3] overflow-hidden py-3 md:py-4 ">
					<div className="w-full h-full relative">
						{/* boton de adorno de alerta */}
						<div className="absolute z-20 left-1.5 md:left-5 md:top-2">
							<div className="h-7 w-7 md:w-8 md:h-8">
								<img className="h-full w-full object-contain" src={icons.alerta} alt="alerta" />
							</div>
						</div>
						{/* boton animacion */}
						<div className="absolute z-20 bottom-0 right-1.5 md:right-5">
							<div className="h-full w-full">
								<div className="h-7 w-7 md:w-8 md:h-8 cursor-pointer" onClick={tooggleAnimation}>
									<img
										className="h-full w-full object-contain"
										src={animacionActiva ? icons.nextArrow : icons.backArrow}
										alt="alerta"
									/>
								</div>
							</div>
						</div>
						{/* div de informacion  opacity-0*/}
						<div ref={containerInfo} className="w-full h-full px-[45px] md:px-[72px] overflow-hidden">
							<div className="w-full h-full grid grid-rows-dialogAnimationGrid md:grid-rows-mddialogAnimationGrid">
								<div className="">
									<p className="text-white font-semibold text-[10px] md:text-[14px]">{nameTitle}</p>
								</div>
								<div className="">
									<p className="text-white text-[12px] md:text-[16px]">{dialog}</p>
								</div>
								<div className="flex items-center">
									<div className="relative w-full bg-[#E6E6E6] h-1">
										<div className="absolute h-full bg-[#FFC427]" style={{ width: percentage }}></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
